import { Callout } from '@doxyme/ui/components/foundations';
import { BodyS, LinkS } from '@doxyme/ui/typography';
import { useTheme } from '@doxyme/ui/theme';
import { FormattedMessage, useIntl } from '@doxyme/locale';
import Box from '@mui/material/Box';
import NextLink from 'next/link';

import type { JSX } from 'react';

const HELP_ARTICLE_LINK =
  'https://helpcenter.doxy.me/en/articles/9893441-invite-via-email-and-text';

export type InviteViaRateLimitMessageProps = {
  messageKey: string;
  date: Date;
};

export const InviteViaRateLimitMessage = ({
  messageKey,
  date,
}: InviteViaRateLimitMessageProps): JSX.Element => {
  const { formatDate, formatTime } = useIntl();

  const theme = useTheme();

  return (
    <Callout level='notice'>
      <BodyS color={theme.text.generic.secondary}>
        <FormattedMessage
          id={messageKey}
          values={{
            link: (
              <NextLink
                target='_blank'
                rel='noreferrer'
                href={HELP_ARTICLE_LINK}
              >
                <LinkS>
                  <FormattedMessage id='rate-limit.helpArticle' />
                </LinkS>
              </NextLink>
            ),
          }}
        />
        <Box
          sx={{
            mt: 5,
          }}
        >
          <BodyS fontWeight='medium'>
            <FormattedMessage
              id='rate-limit.tillDate'
              values={{
                date: formatDate(date),
                time: formatTime(date),
              }}
            />
          </BodyS>
        </Box>
      </BodyS>
    </Callout>
  );
};
